module.exports = __webpack_public_path__ + "static/media/agrocalidad.7469e3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/partnership/agrocalidad.png
// module id = 148
// module chunks = 0